// C2: api.js (no React, no router) sends the browser to the enrollment page
// when the backend answers 403 mfa_required. A full navigation is fine here:
// the user cannot do anything else until a second factor is enrolled.
export function redirectToMfaSetup() {
    if (window.location.pathname !== '/mfa-setup') {
        window.location.assign('/mfa-setup');
    }
}
